import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import { routesFromRestV1 } from 'domain/mappers/routeFromRestV1';
import type { RouteFE } from 'domain/route';

import { errorHandler, formatAxiosError, isAxiosError } from './errors';
import { correlationHeaders, routesRestApi } from './restClient';

const listRoutesFn = async (): Promise<{ data: RouteFE[] }> => {
    try {
        const response = await routesRestApi.get<unknown>('/api/v1/routes/predefined', correlationHeaders());
        return { data: routesFromRestV1(response.data) };
    } catch (error) {
        const loggableError = isAxiosError(error) ? formatAxiosError(error) : error;
        throw errorHandler('Unexpected error occurred while fetching the routes', loggableError);
    }
};

export const routesApi = createApi({
    reducerPath: 'routes',
    // Every endpoint runs on `queryFn`, so the base query is never invoked — routes now come over
    // REST (`GET /api/v1/routes/predefined` on the mission-and-hub service), not GraphQL.
    baseQuery: fakeBaseQuery<unknown>(),
    refetchOnMountOrArgChange: true,
    endpoints: builder => ({
        // The `string` arg is the per-call cache key ('ListRoutes'), the same load-bearing pattern
        // as listHubs; the queryFn ignores its value but the signature must keep it.
        listRoutes: builder.query<RouteFE[], string>({
            queryFn: listRoutesFn,
        }),
    }),
});

export const { useLazyListRoutesQuery, useListRoutesQuery } = routesApi;
